import { Box, Typography } from "@mui/material";
import MrqSelector from "../MRQTab/components/MrqSelector";
import VendorSelector from "./components/vendorSelector";
import LabelledBox from "../../../../../../../components/widgets/LabelledBox";
import { useBidContext } from "./Bid.context";
import BidEvaluationView from "./components/BidEvaluationView";
import ECSBidEvalutionView from "./components/ECSBidEvalutionView";
import TrimListDataSheet from "../Components/TrimListDataSheet";

const MainBidTab = ({ isEcs = false }) => {
  const {
    mrqData,
    mrqList,
    mrqSelection,
    setMrqSelection,
    setSelectedBidMrqData,
    selectedBidVendors,
  } = useBidContext();

  return (
    <Box>
      <Box
        display={"flex"}
        gap={1}
        sx={{ alignItems: "baseline", height: "max-content" }}
      >
        <LabelledBox label="MRQ Manager">
          <MrqSelector
            mrqList={mrqList}
            mrqSelection={mrqSelection}
            setMrqSelection={setMrqSelection}
            setSelectedMrqData={setSelectedBidMrqData}
            defaultValue={mrqData}
          />
        </LabelledBox>
        {mrqSelection?.selectedMrq ? (
          <LabelledBox label="Vendors">
            <VendorSelector isMultiple={true} />
          </LabelledBox>
        ) : (
          <></>
        )}
      </Box>
      {isEcs ? (
        selectedBidVendors?.length > 0 && <ECSBidEvalutionView />
      ) : (
        <BidEvaluationView />
      )}
      {/* ------------  box ! ------------------ */}
    </Box>
  );
};

export default MainBidTab;
